import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SignalRegister } from '../../../shared/interfaces/equipment.interfaces';

const basePath = '/equipment/signal';

@Injectable({
  providedIn: 'root',
})

export class EquipmentSignalService {
  constructor(private http: HttpClient) { }

  // Gets signal level history for a specific equipment
  getSignalLevelHistory(id: number): Observable<SignalRegister[]> {
    return this.http.get<SignalRegister[]>(`${basePath}/${id}`);
  }

}
